import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import {
  AnalyticsGranularity,
  AnalyticsResponse,
  AnalyticsSurveys
} from "src/app/backend/models/analytics";
import { environment } from "src/environments/environment";

@Injectable()
export class AnalyticsSurveysBackend {
  private readonly http = inject(HttpClient);

  list({
    from,
    to
  }: {
    from: string;
    to: string;
  }): Observable<AnalyticsResponse<AnalyticsSurveys>> {
    return this.http
      .get<AnalyticsResponse<AnalyticsSurveys>>(
        `${environment.snoots.api.analytics}/surveys`,
        {
          params: {
            from,
            to,
            granularity: AnalyticsGranularity.MONTHLY,
            groupBy: "satisfaction"
          }
        }
      )
      .pipe(
        map((response) => ({
          ...response,
          totalAverage: response.totalAverage || 0
        }))
      );
  }

  // export(params: {
  //   from: string;
  //   to: string;
  //   granularity: AnalyticsGranularity;
  //   groupBy: AnalyticsSurveysGroupBy;
  // }): Observable<void> {
  //   return this.http.post<void>(
  //     `${environment.snoots.api.analytics}/surveys/exports`,
  //     {
  //       from: params.from,
  //       to: params.to,
  //       granularity: params.granularity,
  //       groupBy: params.groupBy
  //     }
  //   );
  // }
}
